// src/components/intake/bodies/ExclusiveBody.jsx
import React from "react";
import {
  OTHER_MAX,
  OptionCard,
  OptionGrid,
  SetLabel,
  TextAnswer,
} from "../IntakeParts";
import { Q4_EXCLUSIVE, Q4_REVEALS, toggled } from "../intakeRules";
import { CLICK_ALL, Q4_PLANS_LABEL, Q4_PLANS_PLACEHOLDER } from "../intakeCopy";

// Q4 (kind `multiExclusive`): ticking "Nothing right now" clears the others
// and ticking another clears it; "Buying something big…" reveals the plans box.
export default function ExclusiveBody({ page, draft, onChange, idPrefix }) {
  const options = page.questions[0].options;
  const labelId = `${idPrefix}-set-label`;
  const tick = (option) => {
    if (option === Q4_EXCLUSIVE && !draft.selected.includes(option))
      return onChange({ ...draft, selected: [Q4_EXCLUSIVE] });
    const selected = toggled(options, draft.selected, option).filter(
      (o) => option === Q4_EXCLUSIVE || o !== Q4_EXCLUSIVE,
    );
    return onChange({ ...draft, selected });
  };
  return (
    <>
      <SetLabel id={labelId}>{CLICK_ALL}</SetLabel>
      <OptionGrid labelledBy={`${idPrefix}-h1 ${labelId}`}>
        {options.map((option) => (
          <OptionCard
            key={option}
            label={option}
            checked={draft.selected.includes(option)}
            mark={draft.selected.includes(option) ? "✓" : null}
            onChange={() => tick(option)}
          />
        ))}
      </OptionGrid>
      {draft.selected.includes(Q4_REVEALS) && (
        <TextAnswer
          id={`${idPrefix}-plans`}
          label={Q4_PLANS_LABEL}
          placeholder={Q4_PLANS_PLACEHOLDER}
          value={draft.plans}
          max={OTHER_MAX}
          onChange={(plans) => onChange({ ...draft, plans })}
        />
      )}
    </>
  );
}
